import "./CustomRadio.css";
import { Radio } from "@mui/material";

export default function CustomRadio(props) {
  return <Radio {...props} className="custom-radio" />;
}
